import { Plus } from "lucide-react";
import { Button } from "@/shared/ui/button";
import { ValueInputRow } from "./ValueInputRow";
import type { ValueItem } from "./types";

interface AttributeValuesSectionProps {
  values: ValueItem[];
  draggedIndex: number | null;
  dragOverIndex: number | null;
  onValueChange: (id: string, value: string) => void;
  onRemove: (id: string) => void;
  onAdd: () => void;
  onDragStart: (index: number) => void;
  onDragOver: (e: React.DragEvent, index: number) => void;
  onDrop: (e: React.DragEvent, index: number) => void;
  onDragEnd: () => void;
}

export function AttributeValuesSection({
  values,
  draggedIndex,
  dragOverIndex,
  onValueChange,
  onRemove,
  onAdd,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
}: AttributeValuesSectionProps) {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-ink-800">Values</label>
      <div className="space-y-2">
        {values.map((valueItem, index) => (
          <ValueInputRow
            key={valueItem.id}
            valueItem={valueItem}
            index={index}
            draggedIndex={draggedIndex}
            dragOverIndex={dragOverIndex}
            onValueChange={onValueChange}
            onRemove={onRemove}
            onDragStart={onDragStart}
            onDragOver={onDragOver}
            onDrop={onDrop}
            onDragEnd={onDragEnd}
            canRemove={values.length > 1}
          />
        ))}
      </div>
      <Button
        type="button"
        variant="outline"
        onClick={onAdd}
        className="w-full"
      >
        <Plus className="mr-2 h-4 w-4" />
        Add Value
      </Button>
    </div>
  );
}

